import { render, staticRenderFns } from "./addWord.vue?vue&type=template&id=16b884a0&scoped=true&"
import script from "./addWord.vue?vue&type=script&lang=js&"
export * from "./addWord.vue?vue&type=script&lang=js&"
import style0 from "./addWord.vue?vue&type=style&index=0&id=16b884a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b884a0",
  null
  
)

export default component.exports